import React from 'react';
import { Phone, Mail, MessageSquare } from 'lucide-react';

const ClientInformation = ({ client, onMessageClient }) => {
  if (!client) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-2 sm:p-3">
      <h3 className="text-sm sm:text-base font-bold text-black mb-2 sm:mb-3">Client Information</h3>
      <div className="space-y-1.5 sm:space-y-2">
        <div>
          <p className="text-xs text-gray-600 font-medium mb-0.5">Name</p>
          <p className="text-sm font-medium text-black">{client.name}</p>
        </div>
        {client.phone && (
          <div className="flex items-center gap-1.5">
            <Phone className="w-3.5 h-3.5 text-black" />
            <p className="text-xs sm:text-sm text-black">{client.phone}</p>
          </div>
        )}
        {client.email && (
          <div className="flex items-center gap-1.5">
            <Mail className="w-3.5 h-3.5 text-black" />
            <p className="text-xs sm:text-sm text-black">{client.email}</p>
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div className="mt-3 sm:mt-4 pt-3 border-t-2 border-gray-300 space-y-2">
        {client.phone && (
          <a
            href={`tel:${client.phone}`}
            className="flex items-center justify-center gap-2 w-full px-3 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition-colors text-sm font-medium"
          >
            <Phone className="w-4 h-4" />
            Call Client
          </a>
        )}
        <button
          onClick={onMessageClient}
          className="flex items-center justify-center gap-2 w-full px-3 py-2 border border-black text-black rounded-lg hover:bg-gray-100 transition-colors text-sm font-medium"
        >
          <MessageSquare className="w-4 h-4" />
          Message Client
        </button>
      </div>
    </div>
  );
};

export default ClientInformation;

